module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/13@1x.748b97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/uploads/13@1x.png
// module id = mE2c
// module chunks = 3 4